var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
export class DownloadQueueItem {
    constructor() {
        this.id = "";
        this.title = "";
        this.letrid = "";
        this.documentid = "";
        this.queuid = "";
        this.downloadProgress = 0;
        this.downloaderror = false;
        this.inqueue = false;
        this.downloading = false;
        makeObservable(this);
    }
    setInQueue(inqueue) {
        this.inqueue = inqueue;
    }
    setQueueId(id) {
        this.queuid = id;
    }
    setTitle(title) {
        this.title = title;
    }
    setLetrId(letrid) {
        this.letrid = letrid;
    }
    setDocumentId(id) {
        this.documentid = id;
    }
    errorDownloading(error) {
        this.downloaderror = error;
    }
    setDownloadProgress(prog) {
        this.downloadProgress = prog;
    }
    setDownloading(downloading) {
        this.downloading = downloading;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DownloadQueueItem.prototype, "downloadProgress", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DownloadQueueItem.prototype, "downloaderror", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DownloadQueueItem.prototype, "inqueue", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DownloadQueueItem.prototype, "downloading", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DownloadQueueItem.prototype, "setInQueue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DownloadQueueItem.prototype, "setQueueId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DownloadQueueItem.prototype, "setDocumentId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DownloadQueueItem.prototype, "errorDownloading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DownloadQueueItem.prototype, "setDownloadProgress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DownloadQueueItem.prototype, "setDownloading", null);
